// Brand identity constants (founder decision 2026-07-16): brand = zewzew,
// legal entity ZEWZEW LTD, domain zewzew.com. The wordmark is ALWAYS lowercase —
// "zewzew" is all x-height letters (no ascenders/descenders), so the lowercase word
// reads as one uniform band; where a suffix like "RMS" joins it, the suffix is scaled
// so its cap height matches the brand's x-height (see the Wordmark component).
//
// The live brand name is injected by the backend as the `brand` prop
// (Rails.configuration.x.brand_name); FALLBACK_BRAND is used ONLY if that prop is
// somehow absent. Never hardcode a brand name in copy — always use the prop/hook.
export const FALLBACK_BRAND = 'zewzew'

// Legal + contact constants, mirroring config.x.legal_name / config.x.support_email
// on the backend — keep the two in sync. Personal addresses are never exposed.
export const LEGAL_NAME = 'ZEWZEW LTD'
export const SUPPORT_EMAIL = 'support@zewzew.com'
